import { useNavigate, type NavigateFunction, useLocation } from "react-router-dom";
import { useRoutes } from "react-router-dom";
import { useEffect } from "react";
import routes from "./config";

let navigateResolver: (navigate: ReturnType<typeof useNavigate>) => void;

declare global {
  interface Window {
    REACT_APP_NAVIGATE: ReturnType<typeof useNavigate>;
  }
}

export const navigatePromise = new Promise<NavigateFunction>((resolve) => {
  navigateResolver = resolve;
});

export function ScrollToTop() {
  const { pathname } = useLocation();

  // Kill browser scroll restoration immediately (before any render)
  if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual';
  }

  useEffect(() => {
    // Firefox needs a tiny delay — scrollTo must fire AFTER the browser is done
    // with its own scroll restoration. requestAnimationFrame + setTimeout covers all.
    requestAnimationFrame(() => {
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 0);
    });
  }, [pathname]);

  return null;
}

export function AppRoutes() {
  const element = useRoutes(routes);
  const navigate = useNavigate();
  useEffect(() => {
    window.REACT_APP_NAVIGATE = navigate;
    navigateResolver(window.REACT_APP_NAVIGATE);
  });
  return element;
}